import { createAction, createSlice } from "@reduxjs/toolkit";

const getBalanceSlice = createSlice({
  name: "getBalance",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      // console.log(action.payload.data);
      // state.data = action.payload.data.data;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getBalanceSlice;
const getBalanceAction = createAction(name);

export {
  getBalanceAction,
  actions as getBalanceActions,
  reducer as getBalanceReducer,
};
